__turbopack_context__.v({
  "copyTextContainer": "CopyText-module__g5H0mq__copyTextContainer",
  "copyTextInput": "CopyText-module__g5H0mq__copyTextInput",
});
